import { UserManager, WebStorageStateStore } from 'oidc-client';

const userManagerConfig = {
    authority: `${process.env.REACT_APP_URL_AUTH}/auth/realms/clm`,
    client_id: "clm-client",
    redirect_uri: `${process.env.REACT_APP_URL}/login-app/callback`,
    response_type: "code",
    scope: "openid profile email",
    post_logout_redirect_uri: `${process.env.REACT_APP_URL}/logout`,
    userStore: new WebStorageStateStore({ store: window.localStorage }),
    automaticSilentRenew: true,
    loadUserInfo: true,
    silent_redirect_uri: `${process.env.REACT_APP_URL_AUTH}/silent-renew`,
    monitorSession: false,
};
const userManager = new UserManager(userManagerConfig);

export const login = async () => {
    try {
        await userManager.signinRedirect();
    } catch (error) {
        return null;
    }
};

// Função para fazer logout
export const logout = async () => {
    try {
        await userManager.signoutRedirect();
    } catch (error) {
        return null;
    }
};

export const getUser = async () => {
    try {
        const user = await userManager.getUser();
        return user;
    } catch (error) {
        return null;
    }
};

export const handleCallback = async () => {
    try {
        const user = await userManager.signinRedirectCallback();
        return user;
    } catch (error) {
        return null;
    }
};

export const handleRefreshToken = async () => {
    try {
        const user = await userManager.signinSilent();
        return user;
    } catch (error) {
        return null;
    }
}
